export default "__VITE_ASSET__PRIydZOw__"